import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DiariesRoutingModule } from './diaries-routing.module';
import { DiaryListComponent } from './components/diary-list/diary-list.component';
import { DiaryFormComponent } from './components/diary-form/diary-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SearchComponent } from '../../shared/components/search/search.component';
import { FileUploaderComponent } from '../../shared/components/file-uploader/file-uploader.component';
@NgModule({
  declarations: [
    DiaryListComponent,
    DiaryFormComponent
  ],
  imports: [
    CommonModule,
    DiariesRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatIconModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule, // This provides the native DateAdapter
    MatSelectModule,
    MatOptionModule, // This is optional, often included via MatSelectModule
    MatCheckboxModule,
    SearchComponent,
    FileUploaderComponent
  ]
})
export class DiariesModule { }
